<script>
export default {
    name: "YesNoQuestion",
    data() {
        return {
            selectedOption: null,
        }
    },
    methods: {
        checkAnswer() {
            this.$emit('checkInput', this.selectedOption)
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            default: 'Check Answer'
        }
    }
}
</script>

<template>
    <div>
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                :name="`question-${question.id}`"
                :value="true"
                :id="`question-${question.id}-yes`"
                v-model="selectedOption"
            >
            <label class="form-check-label" :for="`question-${question.id}-yes`">Yes</label>
        </div>
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                :name="`question-${question.id}`"
                :value="false"
                :id="`question-${question.id}-no`"
                v-model="selectedOption"
            >
            <label class="form-check-label" :for="`question-${question.id}-no`">No</label>
        </div>
        <button type="button" class="btn btn-secondary" @click="checkAnswer()">{{buttonLabel}}</button>
    </div>
</template>
